import React from 'react';
import { Box, Typography , Button} from '@mui/material';
import { purple } from '@mui/material/colors';
import { useNavigate } from "react-router-dom";

function NotFound() {
    const primary = purple[500]; // #f44336
    const navigate = useNavigate()
    const Volver = () => {
      navigate('/')
    }  
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        backgroundColor: primary,
      }}
    >
      <Typography variant="h1" style={{ color: 'white' }}>
        404
      </Typography>
   
      <Typography variant="h2" style={{ color: 'black' }}>
        Pagina no encontrada
      </Typography>
      <Button variant="contained" sx={{
            marginTop: 8,

          }} onClick = {Volver}>Ir al inicio</Button>
    </Box>
  );
}

export default NotFound